module.exports = __webpack_public_path__ + "img/shuju1.75bd0de4.png";